<script lang="ts" setup>
import { ETitleBlockSizes } from '../ts/types'

withDefaults(
    defineProps<{
        headingBlockSize?: ETitleBlockSizes
        text?: string
        dark?: boolean
    }>(),
    {
        headingBlockSize: ETitleBlockSizes.H1,
    },
)

const sizeMapping = {
    [ETitleBlockSizes.H1]: /* tw */ 'heading-xs md:heading-sm lg:heading-md',
    [ETitleBlockSizes.H2]: /* tw */ 'heading-2xs md:heading-xs lg:heading-xs',
    [ETitleBlockSizes.H3]: /* tw */ '!hidden',
}
</script>

<template>
    <div
        class="text-comp-high-contrast heading-xs line-clamp-4 md:line-clamp-3"
        :class="[sizeMapping[headingBlockSize]]"
        v-html="text"
    />
</template>
